import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import * as actions from './flight-availability-to-checkin.actions';
import { FlightAvailabilityToCheckinState } from './flight-availability-to-checkin.state';

/**
 * flightAvailabilityToCheckin initial state
 */
export const flightAvailabilityToCheckinInitialState: FlightAvailabilityToCheckinState = {
  model: {
    CONNECTION_KIND: '',
    outBoundId: '',
    outDepartureLocation: '',
    outArrivalLocation: '',
    outDepartureDate: '',
    cabinClass: '',
    fareOptionType: '',
  },
};

/**
 * List of basic actions for FlightAvailabilityToCheckin Store
 */
export const flightAvailabilityToCheckinReducerFeatures: ReducerTypes<
  FlightAvailabilityToCheckinState,
  ActionCreator[]
>[] = [
  on(actions.setFlightAvailabilityToCheckin, (_state, payload) => ({ ...payload })),

  on(actions.updateFlightAvailabilityToCheckin, (state, payload) => ({ ...state, ...payload })),

  on(actions.resetFlightAvailabilityToCheckin, () => flightAvailabilityToCheckinInitialState),
];

/**
 * FlightAvailabilityToCheckin Store reducer
 */
export const flightAvailabilityToCheckinReducer = createReducer(
  flightAvailabilityToCheckinInitialState,
  ...flightAvailabilityToCheckinReducerFeatures
);
